import { action, observable } from 'mobx';
import * as React from 'react';

class RefStore {
    @observable appMainContentRef: React.RefObject<HTMLDivElement> | null;

    constructor() {
        this.appMainContentRef = null;
    }

    @action('set main content ref')
    setMainContentRef = (ref: React.RefObject<HTMLDivElement>) => {
        this.appMainContentRef = ref;
    };

    @action('scroll main content ref')
    scrollMainContentRef = (): void => {
        if (!this.appMainContentRef || !this.appMainContentRef.current) return;
        this.appMainContentRef.current.scrollTo(0, 0);
    }
}

const refStore = new RefStore();

export default refStore;
export { RefStore };
